module.exports = __webpack_public_path__ + "static/media/talentPool.4cc91825.svg";